import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import MemberHeader from "@/components/MemberHeader";
import icon_01 from "@/components/Success/images/icon_01.png";
import Unsuccessfully_icon from "@/assets/memberShip/images/unsuccessfully.png";
import MemberButton, {
    MemberAppButtonBox,
} from "@/components/MemberButton";
import { getIsMobile, getDeviceType } from '@/utils/common';
import { useWcipNavigate } from '@/hooks'
import { useTranslation } from "react-i18next";
import NotificationOfMember from "./index";
import "./style.scss";

const ServiceIssues = () =>{
    return <NotificationOfMember pageType="serviceIssues" />
}

export default ServiceIssues;
